import React, { useEffect, useState } from 'react';
import API from '../../api';
import { useCustomers } from '../context/CustomerContext';

export default function PaymentHistoryModal({ customer, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const {  fetchCustomers } = useCustomers();
  useEffect(() => {
    fetchPaymentHistory();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPaymentHistory = async () => {
    try {
      const res = await API.get(`/payments/history/${customer.id}`);
      setHistory(res.data);
    } catch {
      alert('❌ Failed to load payment history');
    } finally {
      setLoading(false);
    }
  };

  const totalReceived = history.reduce((sum, p) => sum + parseFloat(p.received_amount || 0), 0);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-modal="true"
      role="dialog"
    >
      <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center border-b border-gray-300 px-6 py-4">
          <h3 className="text-lg font-semibold">Payment History - {customer.customer_name}</h3>
          <button
            onClick={onClose}
            aria-label="Close modal"
            className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          {loading ? (
            <div className="flex justify-center items-center space-x-2 text-gray-600">
              <svg
                className="animate-spin h-5 w-5 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
              <span>Loading...</span>
            </div>
          ) : history.length === 0 ? (
            <p className="text-center text-gray-500">No payments found.</p>
          ) : (
            <>
              <table className="min-w-full border border-gray-300 rounded text-center text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-3 py-2 w-10">#</th>
                    <th className="border border-gray-300 px-3 py-2">Payment Date</th>
                    <th className="border border-gray-300 px-3 py-2">Amount</th>
                    <th className="border border-gray-300 px-3 py-2">Method / Ref</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((p, idx) => (
                    <tr key={p.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="border border-gray-300 px-3 py-2">{idx + 1}</td>
                      <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                        {new Date(p.payment_date).toLocaleString('en-IN', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })}
                      </td>
                      <td className="border border-gray-300 px-3 py-2">
                        ₹{parseFloat(p.received_amount).toFixed(2)}
                      </td>
                      <td className="border border-gray-300 px-3 py-2">
                        {p.payment_method || '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mt-4 text-right font-semibold text-gray-700">
                Total Received: ₹{totalReceived.toFixed(2)}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
